<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<!--			<v-progress-linear :indeterminate="true" class="ma-0" v-if="scanning"></v-progress-linear>-->

			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-2>
				<div v-if="errorMessage == 'activation'">
					<div class="mb-4">
						<h3>De E-Finder kan niet worden gekoppeld</h3><br>
						<p>De communicatie tussen de telefoon je E-Finder is verstoord. Hierdoor hebben we de E-Finder
							niet goed kunnen instellen.</p>
						<p>Het kan voorkomen dat het signaal toch goed is doorgekomen. Dan zie je ongeveer over een uur
							de eerste lokaties op de kaart.</p>
						<v-btn :loading="saving" block dark depressed large color="primary" @click="errorMessage = null"
							   class="mt-4">
							Probeer opnieuw
						</v-btn>
					</div>
				</div>
				<div v-else>
					<div class="mb-4" v-if="hasScanned && !bleDevice">

						<div v-if="scanning">
							<h3>Zoeken naar je E-finder</h3><br>
							<p>Een moment geduld aub...</p>
						</div>

						<div v-else>
							<h3>Geen E-finder gevonden</h3><br>
							<ol>
								<li>Gebruik de meegeleverde kabel om je E-finder aan te sluiten aan het netstroom.</li>
								<li>Controleer of de code op je E-finder klopt: {{ device.eid.substr(-6) }}</li>
								<li>Haal je E-finder even van het netstroom af en zet hem er dan weer aan, klik daarna op
									opnieuw verbinden hier onder.
								</li>
							</ol>
						</div>

						<v-btn :loading="scanning" block dark depressed large color="primary" @click="searchForDevice()"
							   class="mt-4">
							Opnieuw verbinden
						</v-btn>
					</div>
					<div :class="{'is-disabled': !bleDevice}" v-else>
						<p>De huidige versie van de E-finder werkt alleen met 2.4GHz WiFi netwerken.</p>
						<p>Wanneer er geen 2.4GHz netwerk beschikbaar is klik dan op overslaan. Het is ook mogelijk om
							deze later in te voeren.</p>
						<p>Om automatisch de firmware updates te installeren kun je de Tutorial over WiFi netwerken
							raadplegen in het Help & Support scherm.</p>
						<h3>Geef je WiFi gegevens op:</h3>
						<v-text-field
							v-model="wifiName"
							label="WiFi Naam"
							required
							:error-messages="errorMessage"
							:hide-details="true"
						></v-text-field>
						<v-text-field
							v-model="wifiPassword"
							label="WiFi Password"
							required
							:error-messages="errorMessage"
						></v-text-field>
						<v-btn :loading="saving" block dark depressed large color="primary" @click="save()"
							   class="mt-4">
							Opslaan
						</v-btn>
					</div>
				</div>

			</v-container>

			<v-container v-if="bleDevice && errorMessage != 'activation'">
				<v-layout class="column align-center">
					<v-btn depressed color="white" @click="skip()">Overslaan</v-btn>
				</v-layout>
			</v-container>
		</v-content>
	</div>
</template>

<script>
	import DeviceService from '../../../services/DeviceService';

	let checkForBleServiceInterval;

	const characteristics = {
		activation: {
			uuid: '1fb91a52-0000-49da-a31a-0401cc94acc4'
		},
		ssid: {
			uuid: 'eac0d61a-0000-e3f3-baeb-38ddd48474eb'
		},
		password: {
			uuid: 'eac0d61a-0001-e3f3-baeb-38ddd48474eb'
		},
		isFound: {
			uuid: 'c01ff0ad-0000-43b9-a6ef-cf71ba1eb665'
		}
	};

	function stringToBytes(_str) {
		let str = _str + '';
		let a = new Uint8Array(str.length);
		for (let i = 0, l = str.length; i < l; i++) {
			a[i] = str.charCodeAt(i);
		}
		return a.buffer;
	}

	// ASCII only
	function bytesToString(buffer) {
		return String.fromCharCode.apply(null, new Uint8Array(buffer));
	}

	export default {
		computed: {
			device() {
				return this.$store.getters.device;
			},
			userLocation() {
				return this.$store.state.location.coordinates;
			},
		},
		data() {
			return {
				bleEnabled: false,
				bleDevice: null,
				scanning: false,
				hasScanned: false,
				saving: false,
				wifiName: '',
				wifiPassword: '',
				errorMessage: ''
			};
		},
		methods: {
			showMenu() {
				this.$store.dispatch('toggleMainMenu');
			},
			gotoOverview() {
				this.$router.push({ name: 'devices.list' });
			},
			goBack() {
				this.$router.push({ name: 'devices.activate.link', params: { id: this.device.id } });
			},

			checkForBleService() {
				if (typeof ble === 'undefined') return false;
				ble.isEnabled(() => this.enableBle(), () => this.disableBle());
			},

			enableBle() {
				if (this.bleEnabled) return;
				this.bleEnabled = true;
				this.searchForDevice();
			},

			disableBle() {
				if (!this.bleEnabled) return;
				this.bleEnabled = false;
			},

			searchForDevice() {
				if (typeof ble === 'undefined') return false;

				this.scanning = true;
				this.hasScanned = true;

				this.$store.dispatch('bleConnect', this.device.eid)
					.then(bleDevice => {
						console.log('CONNECTED WIFI');
						this.scanning = false;
						this.bleDevice = bleDevice;
					})
					.catch(e => {
						console.log(e);
						this.scanning = false;
					});
			},

			connectDevice(deviceId) {
				if (typeof ble === 'undefined') return false;

				ble.connect(deviceId, (device) => {
					// if (!this.validateDevice(device)) return;
					this.bleDevice = device;
				});
			},

			getCharacteristic(uuid, device = null) {
				device = device === null ? this.bleDevice : device;

				if (!device && !device.characteristics) return undefined;

				return device.characteristics.find(deviceCharacteristic => {
					return deviceCharacteristic.characteristic.toUpperCase() === uuid.toUpperCase();
				});
			},

			getCharacteristicOnService(service, characteristic, device = null) {
				device = device === null ? this.bleDevice : device;

				if (!device && !device.characteristics) return undefined;

				return device.characteristics.find(deviceCharacteristic => {
					return deviceCharacteristic.characteristic.toUpperCase() === characteristic.toUpperCase()
						&& deviceCharacteristic.service.toUpperCase() === service.toUpperCase();
				});
			},

			saveWiFiName(_wifiName) {
				return new Promise((resolve, reject) => {
					const ch = this.getCharacteristic(characteristics.ssid.uuid);
					ble.write(this.bleDevice.id, ch.service, ch.characteristic, stringToBytes(_wifiName), resolve, reject);
				});
			},

			saveWiFiKey(_wifiKey) {
				return new Promise((resolve, reject) => {
					const ch = this.getCharacteristic(characteristics.password.uuid);
					ble.write(this.bleDevice.id, ch.service, ch.characteristic, stringToBytes(_wifiKey), resolve, reject);
				});
			},

			activateDevice() {
				return new Promise((resolve, reject) => {
					if (!this.bleDevice) return reject();

					const characteristic = this.getCharacteristic(characteristics.activation.uuid);
					const characteristicSuccess = {
						service: '1FB91A52-A1DB-49DA-A31A-0401CC94ACC4',
						characteristic: 'EAC0D61A-0002-E3F3-BAEB-38DDD48474EB'
					};

					let data = new Uint8Array(1);
					data[0] = 1;

					console.log('HAS NOTIFY', !!this.getCharacteristicOnService(characteristicSuccess.service, characteristicSuccess.characteristic));

					if (this.getCharacteristicOnService(characteristicSuccess.service, characteristicSuccess.characteristic)) {
						const timeout = setTimeout(() => {
							ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
							console.log('DEVICE ACTIVATION FAILED');
							// resolve();
							reject();
						}, 10000);

						ble.startNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic, (data) => {
							ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
							clearTimeout(timeout);
							console.log('DEVICE ACTIVATED');
							resolve();
						}, reject);

						console.log('DEVICE ACTIVATING');
						ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer, () => null, reject);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 1000);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 2000);
					} else {
						console.log('DEVICE ACTIVATING');
						ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 1000);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 2500);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 5000);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 7500);
						setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer, () => {
							console.log('DEVICE ACTIVATION SENDED');
							resolve();
						}, reject), 10000);
					}
				});
			},

			async notifyActivation() {
				const data = { activated_at: true };
				if (!this.device.latest_state && this.userLocation && this.userLocation.lat != 0 && this.userLocation.lng != 0) {
					data.latest_state = {
						accuracy: '10',
						battery_percentage: '100',
						battery_status: 'Green',
						battery_voltage: '5',
						btle_address: '',
						deadtime_delay: '5',
						firmware: '-',
						gateway_location: this.userLocation,
						is_moving: false,
						location: this.userLocation,
						measure_interval: '5',
						message_interval: '1440',
						processed_at: null,
						received_at: null,
						send_at: null,
						state: 'Standard',
						state_id: null,
						type: 'gps',
						wifi_result: ''
					};
					try {
						await DeviceService.createDeviceState(this.device.id, this.userLocation);
					} catch (e) {
					}
				}

				await this.$store.dispatch('updateDevice', { id: this.device.id, data: data });
			},

			async skip() {
				if (!this.bleDevice) {
					return this.errorMessage = 'Er is geen Bluetooth verbinding met je E-finder';
				}

				if (this.saving) return;
				this.saving = true;

				try {
					await this.activateDevice();
				} catch (e) {
					this.saving = false;
					return this.errorMessage = 'activation';
				}

				await this.notifyActivation();

				this.$router.push({ name: 'devices.activate.wifi-success', props: { id: this.$route.params.id } });
			},

			async save() {
				if (!this.bleDevice) {
					return this.errorMessage = 'Er is geen Bluetooth verbinding met je E-finder';
				}

				if (this.saving) return;
				this.saving = true;

				await this.saveWiFiName(this.wifiName);
				await this.saveWiFiKey(this.wifiPassword);

				try {
					await this.activateDevice();
				} catch (e) {
					this.saving = false;
					return this.errorMessage = 'activation';
				}

				await this.notifyActivation();

				this.$router.push({ name: 'devices.activate.wifi-success', props: { id: this.$route.params.id } });
			},
		},
		created() {
			this.$store.dispatch('selectDevice', this.$route.params.id);
			this.checkForBleService();
			checkForBleServiceInterval = setInterval(this.checkForBleService, 3000);
		},
		beforeDestroy() {
			if (typeof ble === 'undefined') return;
			ble.stopScan();
			clearInterval(checkForBleServiceInterval);
		}
	};
</script>

<style lang="stylus">
	.uf-form {
		position: relative;
		background-color: #f2f2f2;
	}

	.item-group {
		background-color: #fff;
		border-top: solid 1px #ddd;
		border-bottom: solid 1px #ddd;
	}

	.is-disabled {
		opacity: .5;
		pointer-events: none;
	}
</style>
